module.exports = __webpack_public_path__ + "img/1.59447992.png";